import swal from "sweetalert";

export default class confirmDialog {

    async alert(heading, body  ) {
        console.log("alert",heading, body );
        let message = heading;
        if(body) message = message+ "\n" + body;
        await swal("Server error", message);
    }

}